module.exports = __webpack_public_path__ + "static/media/trucks.493de728.png";